var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "url(#paint0_linear_3954_2055)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "url(#paint1_linear_3954_2055)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "url(#paint2_linear_3954_2055)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "url(#paint3_linear_3954_2055)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.668 30.4531V37.461H24.9922V30.4531H34.668Z",
    stroke: "#FFD119",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6693 32.9096C39.2784 32.6246 38.6093 27.4892 36.5113 27.0746C35.8334 25.0388 34.4272 24.8563 33.0501 24.5988C31.5763 21.9405 28.8013 22.0588 27.0376 23.7963C26.5155 23.748 25.9914 23.8653 25.5397 24.1316C25.088 24.3979 24.7317 24.7998 24.5213 25.2801C19.7034 27.4988 22.4547 32.1492 24.9934 32.2496",
    stroke: "#FFD119",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2935 27.2881L32.0002 26.5469L31.7969 28.8948L34.2935 27.2881Z",
    stroke: "#FFD119",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5998 32.2547C33.349 31.8814 34.7902 30.4943 33.0473 28.0859M34.669 35.3443L32.4094 33.0847L30.7765 34.7176L30.224 34.1647L26.9219 37.4668",
    stroke: "#FFD119",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7159 33.5725C28.1329 33.5725 28.4709 33.2345 28.4709 32.8175C28.4709 32.4005 28.1329 32.0625 27.7159 32.0625C27.299 32.0625 26.9609 32.4005 26.9609 32.8175C26.9609 33.2345 27.299 33.5725 27.7159 33.5725Z",
    stroke: "#FFD119",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3954_2055",
    x1: 4.93903,
    y1: 63.2927,
    x2: 62.7439,
    y2: -4.02439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#FFD119",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3954_2055",
    x1: 59.8171,
    y1: -7.68292,
    x2: 4.93902,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#FFD119",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3954_2055",
    x1: 3.20968,
    y1: 10.4839,
    x2: 51.8226,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#FFD119",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3954_2055",
    x1: 60.6935,
    y1: 61.9355,
    x2: 9.59677,
    y2: 25.7419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#FFD119",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.09a8c7e662112338bad76b0567af0a03.svg";
export { ForwardRef as ReactComponent };